var $ = require('jquery');
var HelpLinks = require('./helpLinks');

/**
 * Toolbar - Help class
 *
 * Renders the help icon in the toolbar
 *
 * @depends jquery.js
 * @depends extendClass.js
 */
(function() {
    'use strict';
    var Help;

    Help = Klazz.extend({
        options: {},
        toolbar: null,
        element: null,
        helpEl: null,
        messages: {

        },

        initialize: function(toolbar) {
            this.toolbar = toolbar;
            this.options = $.extend(true, {}, this.options); // note: we break object reference

            // get translations //
            // note: we break object reference
            this.messages = $.extend(true, {}, this.messages, jimdoData.messages.helptoolbar);

            this.draw();
        },
        draw: function(){
            if (diy.context.type != 'editor') {
                return;
            }

            var elementHtml = '' +
                '<div class="spacer"><div class="icon"></div></div>' +
                '<div class="helpContainer">' +
                    '<a class="help" title="' + this.messages.title + '">' +
                        '<div class="ui-icon ui-icon-help"></div>' +
                    '</a>' +
                '</div>';
            this.element = this.toolbar.pushToPanel('right', elementHtml);

            this.helpEl = this.element.find('.help');

            this.helpEl
                .diy_calloutLayer({
                    cls: 'diye-help-toolbar',
                    anchorTarget: this.helpEl,
                    positionMode: 'fixed',
                    position: {
                        my: 'right top',
                        at: 'right bottom',
                        offset: '10 ' + (diy.editor.uiPreference.isPointerModeTouch() ? '11' : '0')
                    }
                })
                .bind('mouseenter', $.proxy(function() {
                    this.helpEl.addClass('ui-state-hover');
                }, this))
                .bind('mouseleave', $.proxy(function() {
                    this.helpEl.removeClass('ui-state-hover');
                }, this))
                .bind('click', $.proxy(this._onHelpIconClick, this));

            $('#diyToolbar').bind('diy-editor-toolbar-repositioned', $.proxy(this._positionLayer, this));
        },

        _positionLayer: function() {
            this.helpEl.diy_calloutLayer('refresh');
        },

        _onHelpIconClick: function(e, ui) {
            //XXX: this function is based on the fact that diy_calloutLayer is initialized on this.helpEl
            //... but it does not take any precaution for the opposite situation.
            var helpEl = this.helpEl;
            if (helpEl.diy_calloutLayer('isVisible')) {
                helpEl.diy_calloutLayer('hide');
                return;
            }
            helpEl.diy_calloutLayer('render');
            this._renderHelpLinks();
            helpEl.diy_calloutLayer('show');
            return;
        },

        _renderHelpLinks: function() {
            var contentEl = this.helpEl.diy_calloutLayer('getContentEl'),
                $helpLinks, helpLinksWidget;

            if (!contentEl) {
                return;
            }

            contentEl.empty();

            $helpLinks = $('<div></div>')
                .addClass('help-links')
                .appendTo(contentEl);

            helpLinksWidget = new HelpLinks($helpLinks);
            helpLinksWidget.render();

            $helpLinks.bind('helplinksclick', $.proxy(this._onHelpLinkClick, this));
        },

        _onHelpLinkClick: function(e, data) {
            this.helpEl.diy_calloutLayer('hide');
        }
    });

    module.exports = Help;
}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/help/help.js
 ** module id = 855
 ** module chunks = 0
 **/